import { Termin } from '@/domain/termine/shared/types/Termin';
import { Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { TerminPopoverContent } from './TerminPopoverContent';
import { TerminDeleteDialog } from './TerminDeleteDialog';
import { useState } from 'react';
import { cn } from '@/lib/utils';

export function TerminPopover({
  termin,
  children,
}: {
  termin: Termin;
  children: React.ReactNode;
}) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <Popover modal>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className={cn(
          'w-85 bg-white shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),0_2px_15px_-3px_rgba(0,0,0,0.1)] rounded-lg p-0 border-none overflow-visible',
          'max-w-(--radix-popover-content-available-width)',
          'max-h-(--radix-popover-content-available-height)',
          'flex relative items-start justify-center',
        )}
        tabIndex={-1}
        avoidCollisions
        collisionPadding={16}
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        onInteractOutside={(e) => {
          e.stopPropagation();
        }}>
        <TerminPopoverContent
          termin={termin}
          onDeleteClick={() => setDeleteDialogOpen(true)}
        />
      </PopoverContent>
      <TerminDeleteDialog
        termin={termin}
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
      />
    </Popover>
  );
}
